import { useMemo } from "react";
import { dramas } from "@/mocks/dramas";
import SectionHeading from "@/pages/home/components/SectionHeading";
import Reveal from "@/components/feature/Reveal";

const medal = ["bg-accent-500 text-foreground-950", "bg-secondary-400 text-foreground-950", "bg-primary-400 text-background-50"];

export default function Ranking() {
  const ranked = useMemo(
    () => [...dramas].sort((a, b) => b.viewers - a.viewers).slice(0, 10),
    [],
  );
  const max = ranked[0]?.viewers ?? 1;

  return (
    <section id="ranking" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-5xl mx-auto">
        <SectionHeading
          eyebrow="Viewer Ranking"
          title="人气剧榜单 TOP 10"
          desc="按站内累计观看热度排序，反映近期观众的关注集中度。热度高说明讨论人多，得分高代表口碑稳，两条线索结合着看会更准确。"
          align="center"
        />

        <ol className="mt-8 md:mt-10 space-y-3">
          {ranked.map((drama, index) => {
            const width = Math.max(6, Math.round((drama.viewers / max) * 100));
            return (
              <Reveal as="li" key={drama.id} delay={Math.min(index, 6) * 50}>
                <article className="group rounded-lg border border-background-200 bg-background-100 hover:border-primary-300 transition-colors px-4 md:px-5 py-4 flex items-center gap-4">
                  <span
                    className={`w-8 h-8 md:w-9 md:h-9 shrink-0 rounded-md flex items-center justify-center font-heading font-bold text-sm ${
                      index < 3 ? medal[index] : "bg-background-300 text-foreground-700"
                    }`}
                  >
                    {index + 1}
                  </span>

                  <span className="w-14 h-20 shrink-0 rounded-md overflow-hidden bg-background-200">
                    <img
                      src={drama.poster}
                      alt={`${drama.title} 人气韩剧海报缩略图`}
                      title={`${drama.title} 韩剧 人气榜单`}
                      className="w-full h-full object-cover object-top"
                    />
                  </span>

                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="font-heading font-bold text-foreground-950 truncate">
                        {drama.title}
                      </h3>
                      {drama.exclusive ? (
                        <span className="px-2 py-0.5 rounded text-[11px] font-label bg-primary-100 text-primary-700">
                          独播
                        </span>
                      ) : null}
                    </div>
                    <p className="mt-1 text-xs font-label text-foreground-500">
                      {drama.year} · {drama.genres.join(" / ")} · 评分 {drama.score.toFixed(1)}
                    </p>
                    <div className="mt-2.5 h-1.5 w-full rounded-full bg-background-300/70 overflow-hidden">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                        style={{ width: `${width}%` }}
                      />
                    </div>
                  </div>

                  <div className="shrink-0 text-right">
                    <p className="font-heading font-bold text-primary-700 text-base md:text-lg">
                      {drama.viewers}
                      <span className="ml-0.5 text-xs font-label font-normal text-foreground-500">
                        万
                      </span>
                    </p>
                    <p className="text-[11px] font-label text-foreground-400 mt-0.5">
                      观看热度
                    </p>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </ol>
      </div>
    </section>
  );
}